var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hue",style:({width: `${_vm.width}px`, height: `${_vm.height}px`}),on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectHue.apply(null, arguments)}}},[_c('canvas',{ref:"canvasHue"}),_c('div',{class:`slide ${_vm.direction}`,style:(_vm.slideHueStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }